import { COUNTRY, IJOIST_INPUT_TYPE } from '../../../utils/constants'

export const APP_CONFIG = {
  appCode: 'HS',
  appVersion: '1.5.1',
  appName: 'Hanger Selector',
  logoUrl: 'assets/images/hs/hs-logo.svg',
  gaEventName: 'HS_Events',
  downloadFileName: 'HS-DATA',
  productThemeClasses: '-themeConnectors',
  navigationConfig: {
    showTutorial: true,
  },
}

/** PRELOADED STATE */
export const APP_STATE_KEY = `sst_bp_${APP_CONFIG.appCode}_app-state`

export const INPUT_OPTIONS = [
  {
    value: 0,
    text: 'Select by manufacturer info',
  },
  {
    value: 1,
    text: 'Input dimensions manually',
  },
]

export const TOPFLANGE_BEND_MARKS = [
  {
    value: -30,
    label: '-30°',
  },
  {
    value: 0,
    label: '0°',
  },
  {
    value: 30,
    label: '30°',
  },
]

export const TOPFLANGE_SLOPE_MARKS = [
  {
    value: -35,
    label: '-35°',
  },
  {
    value: 0,
    label: '0°',
  },
  {
    value: 35,
    label: '35°',
  },
]

export const HIP_SLOPE_SKEW_DEGREES_MARKS = [
  {
    value: 0,
    label: '0°',
  },
  {
    value: 45,
    label: '45°',
  },
  {
    value: 85,
    label: '85°',
  },
]

export const SLOPE_DEGREES_MARKS = [
  {
    value: -49,
    label: '-49°',
  },
  {
    value: 0,
    label: '0°',
  },
  {
    value: 49,
    label: '49°',
  },
]

export const SKEW_DEGREES_MARKS = [
  {
    value: -85,
    label: '-85°',
  },
  {
    value: -45,
    label: '-45°',
  },
  {
    value: 0,
    label: '0°',
  },
  {
    value: 45,
    label: '45°',
  },
  {
    value: 85,
    label: '85°',
  },
]

export const DEFAULT_TOP_FLANGE_VALUES = {
  topFlangeOpenClosedType: 0,
  topFlangeOpenClosedAngle: 0,
  topFlangeSlopedDownType: 0,
  topFlangeSlopedDownAngle: 0,
  topFlangeOffset: 0,
  hlcFlush: 1,
}

export const DEFAULT_HANGER_ANGLE_VALUES = {
  skewType: 0,
  skewAngle: 0,
  slopeType: 0,
  slopeAngle: 0,
}

export const CONNECTION_TYPE = {
  JOIST: 'joist',
  TRUSS: 'truss',
  MULTI_TRUSS: 'multiTruss',
}

export const BUILDING_CODE = {
  [COUNTRY.USA]: 20,
  [COUNTRY.CANADA]: 41,
}

export const ANSI_TPI = {
  [COUNTRY.USA]: 6,
  [COUNTRY.CANADA]: 0,
}

export const HANGER_TYPE = {
  FACE_MOUNT: 1,
  TOP_FLANGE: 2,
  CONCEALED: 3,
  ALL_TYPES: 0,
}

export const ANGLE_SLOPE_TYPE = {
  NONE: 0,
  UP: 1,
  DOWN: 2,
}

export const ANGLE_SKEW_TYPE = {
  NONE: 0,
  LEFT: 1,
  RIGHT: 2,
}

export const OPEN_CLOSED_TYPE = {
  NONE: 0,
  CLOSED: 1,
  OPEN: 2,
}

export const SLOPED_DOWN_TYPE = {
  NONE: 0,
  LEFT: 1,
  RIGHT: 2,
}

export const CONCEALED_TYPE = {
  ANY: 0,
  NO: 1,
  YES: 2,
}

export const HLC_FLUSH = {
  LOW: 0,
  CENTER: 1,
  HIGH: 2,
}

export const LEDGER_TYPE = {
  NO: 0,
  YES: 1,
}

export const CONFIGURATION = {
  LEFT_CENTER: 'leftCenter',
  LEFT_RIGHT: 'leftRight',
  CENTER_RIGHT: 'centerRight',
  LEFT_CENTER_RIGHT: 'leftCenterRight',
}

export const CARRIED_MEMBER = {
  JOIST: 'joist',
  TRUSS: 'truss',
  JACK: 'jack',
  LEFT_HIP: 'leftHip',
  RIGHT_HIP: 'rightHip',
}

export const OUTPUT_TAB = {
  RESULT: 'result',
  JOB_TALLY: 'jobTally',
}

export const DEFAULT_SETTING_STATE = {
  country: COUNTRY.USA,
  connectionType: CONNECTION_TYPE.JOIST,
}

export const DEFAULT_JOBSETTINGS_STATE = {
  ansitpi: 6,
  hangerType: 0,
  downloadDurationType: 100,
  upliftLoadDurationType: 160,
  jobID: 'Job 1',
  quantity: 1,
  configuration: 'leftCenterRight',
}

export const HANGER_TYPE_LABEL = {
  1: 'Face Mount',
  2: 'Top Flange',
  3: 'Concealed Flange',
  0: 'All Types',
}

export const HEADER_TYPE_LABEL = {
  solidSawn: 'Solid Sawn',
  glulam: 'Glulam',
  lsl: 'Laminated Strand Lumber',
  lvl: 'Laminated Veneer Lumber',
  psl: 'Parallel Strand Lumber',
  ijoist: 'I-Joist',
  floorTruss: 'Floor Truss',
  ledger: 'Ledger',
  masonry: 'Masonry - Mid-Wall',
  masonryTopWall: 'Masonry - Top-of-Wall',
  concrete: 'Concrete',
  ssteel: 'Structural Steel',
  nailer: 'Nailer',
  wallSFlush: 'Wall, Sheathed Flush',
  wallSGap: 'Wall, Sheathed Gap',
  wallDFlush: 'Wall, Drywall Flush',
  wallDFlushStud: 'Wall, Drywall Flush @ Stud',
  wallDGap: 'Wall, Drywall Gap',
}

export const JOIST_TYPE_LABEL = {
  solidSawn: 'Solid Sawn',
  glulam: 'Glulam',
  lsl: 'Laminated Strand Lumber',
  lvl: 'Laminated Veneer Lumber',
  psl: 'Parallel Strand Lumber',
  ijoist: 'I-Joist',
  floorTruss: 'Floor Truss',
}

export const GIRDER_TYPE_LABEL = {
  solidSawn: 'Truss',
  glulam: 'Glulam',
  lsl: 'Laminated Strand Lumber',
  lvl: 'Laminated Veneer Lumber',
  psl: 'Parallel Strand Lumber',
  ledger: 'Ledger',
  masonry: 'Masonry',
  concrete: 'Concrete',
}

export const TRUSS_TYPE_LABEL = {
  truss: 'Truss',
  glulam: 'Glulam',
  lsl: 'Laminated Strand Lumber',
  lvl: 'Laminated Veneer Lumber',
  psl: 'Parallel Strand Lumber',
  floorTruss: 'Floor Truss',
  ijoist: 'I-Joist',
}

export const CONNECTION_TYPE_LABEL = {
  joist: 'Joist (Flush Top)',
  truss: 'Truss (Flush Bottom)',
  multiTruss: 'Multi-Truss (Flush Bottom)',
}

export const IJOIST_INPUT_OPTIONS = [
  {
    value: IJOIST_INPUT_TYPE.MANUFACTURER,
    text: 'Select by manufacturer info',
  },
  {
    value: IJOIST_INPUT_TYPE.MANUALLY,
    text: 'Input dimensions manually',
  },
]

export const JOIST_MEMBER_TYPE = {
  TRUSS: 'truss',
  SOLID_SAWN: 'solidSawn',
  GLULAM: 'glulam',
  LAMINATED_STRAND_LUMBER: 'lsl',
  LAMINATED_VENEER_LUMBER: 'lvl',
  PARALLEL_STRAND_LUMBER: 'psl',
  IJOIST: 'ijoist',
  FLOOR_TRUSS: 'floorTruss',
}

export const MEMBER_TYPE = {
  TRUSS: 'truss',
  SOLID_SAWN: 'solidSawn',
  GLULAM: 'glulam',
  LAMINATED_STRAND_LUMBER: 'lsl',
  LAMINATED_VENEER_LUMBER: 'lvl',
  PARALLEL_STRAND_LUMBER: 'psl',
  IJOIST: 'ijoist',
  FLOOR_TRUSS: 'floorTruss',
  MASONRY: 'masonry',
  MASONRY_MID_WALL: 'masonryMidWall',
  MASONRY_TOP_WALL: 'masonryTopWall',
  LEDGER: 'ledger',
  CONCRETE: 'concrete',
  STRUCTURE_STEEL: 'ssteel',
  NAILER: 'nailer',
  WALL_SHEATED_FLUSH: 'wallSFlush',
  WALL_SHEATED_GAP: 'wallSGap',
  WALL_DRYWALL_FLUSH: 'wallDFlush',
  WALL_DRYWALL_GAP: 'wallDGap',
  WALL_DRYWALL_FLUSH_STUD: 'wallDFlusStud',
}

export const OFFSET_TYPE = {
  CENTERED: 0,
  LEFT: 1,
  RIGHT: 2,
}

export const DEFAULT_NUMBER_OF_PLIES = 1

export const APP_VERSION = {
  CURRENT: APP_CONFIG.appVersion,
  '1.5.0': '1.5.0',
  '1.4.2': '1.4.2',
  '1.4.1': '1.4.1',
  '1.4.0': '1.4.0',
  '1.3.0': '1.3.0',
  '1.2.0': '1.2.0',
  '1.1.0': '1.1.0',
  '1.0.1': '1.0.1',
  '1.0.0': '1.0.0',
}

export const APP_VERSION_STORAGE_KEY = 'app_hs_version'

export const ACCORDION_TYPE = {
  SINGLE: 'single',
  MULTIPLE: 'multiple',
}

export const LEDGER_MATERIAL_LIST = {
  LSL: 12,
  LVL_DF_SP: 13,
  PSL: 14,
  LVL_SPF: 21,
}
